import { render, staticRenderFns } from "./FieldMappings.vue?vue&type=template&id=7222aca8&scoped=true&"
import script from "./FieldMappings.vue?vue&type=script&lang=js&"
export * from "./FieldMappings.vue?vue&type=script&lang=js&"
import style0 from "./FieldMappings.vue?vue&type=style&index=0&id=7222aca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222aca8",
  null
  
)

export default component.exports